import { memo } from 'react';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';

/**
 * SavedViewsControl - Dropdown to select/delete saved views and save button
 */
const SavedViewsControl = memo(({
  savedViews,
  activeViewName,
  setActiveViewName,
  loadView,
  saveCurrentView,
  deleteView,
  confirmDelete,
  handleConfirmDelete,
  handleCancelDelete,
}) => (
  <>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {Object.keys(savedViews).length > 0 && (
        <FormControl size='small' sx={{ minWidth: 140 }}>
          <Select
            id="saved-views-select"
            name="savedViews"
            displayEmpty
            value={activeViewName === 'Custom' ? '' : activeViewName}
            onChange={e => {
              if (e.target.value) {
                setActiveViewName(e.target.value);
                loadView(e.target.value);
              }
            }}
            renderValue={() => (activeViewName === 'Custom' ? 'Views' : activeViewName)}
          >
            {Object.keys(savedViews).map(n => (
              <MenuItem
                key={n}
                value={n}
                sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}
              >
                <span>{n}</span>
                <Button
                  size='small'
                  onClick={ev => {
                    ev.stopPropagation();
                    deleteView(n);
                  }}
                >
                  (x)
                </Button>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <Tooltip title="Save current view" enterDelay={200} leaveDelay={200} arrow>
        <IconButton
          size='small'
          onClick={() => {
            saveCurrentView();
            setActiveViewName('Custom');
          }}
          sx={{
            border: '1px solid #e0e0e0',
            borderRadius: 1,
            '&:hover': {
              bgcolor: '#f5f5f5',
              borderColor: '#c0c0c0'
            }
          }}
        >
          <BookmarkIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>

    {/* Confirm Delete Dialog */}
    {confirmDelete.open && (
      <Dialog open={true} onClose={handleCancelDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete saved view '{confirmDelete.name}'?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color='primary'>
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color='error'>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    )}
  </>
));

SavedViewsControl.displayName = 'SavedViewsControl';

export default SavedViewsControl;
